module.exports = __webpack_public_path__ + "static/img/excel.f46854af.svg";